export enum ShoppingMetricsTabName {
  PerformanceMetrics = 'performanceMetrics',
  SizeOfAccount = 'sizeOfAccount',
  PerformanceTracker = 'performanceTracker'
}
